import { API_CONFIG, apiCall } from './api';

export const spinWheelAPI = {
  getStats: async ({ dateFilter = 'all_time', startDate = '', endDate = '' } = {}) => {
    const params = new URLSearchParams({ dateFilter });
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    const query = params.toString();
    const endpoint = `${API_CONFIG.ENDPOINTS.SPIN_WHEEL_STATS}?${query}`;
    return apiCall(endpoint, { method: 'GET' });
  },

  getWinnersHistory: async ({ page = 1, limit = 20 } = {}) => {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    });
    const endpoint = `${API_CONFIG.ENDPOINTS.SPIN_WHEEL_WINNERS_HISTORY}?${params}`;
    return apiCall(endpoint, { method: 'GET' });
  },
};
